import type { Icon, IconProps } from '@tabler/icons-react'
import {
  IconAddressBook,
  IconBuildingPlus,
  IconCertificate,
  IconCloudLock,
  IconCreditCard,
  IconFileTextSpark,
  IconForms,
  IconKey,
  IconLinkPlus,
  IconMailPlus,
  IconNetwork,
  IconPlugConnected,
  IconShieldLock,
  IconTicket,
  IconUserCircle,
  IconUserPlus,
  IconWebhook,
  IconWorldPlus,
} from '@tabler/icons-react'

import { CreateIcon } from './create-icon'

function withPlus(icon: Icon): Icon {
  function EntityCreateIcon(props: IconProps) {
    return <CreateIcon icon={icon} {...props} />
  }
  return EntityCreateIcon
}

export const CreateEnvelopeIcon = IconMailPlus
export const CreateTemplateIcon = withPlus(IconFileTextSpark)
export const CreateContactIcon = withPlus(IconAddressBook)
export const CreateVaultIcon = withPlus(IconShieldLock)
export const CreateUserIcon = IconUserPlus
export const CreateAccountIcon = IconBuildingPlus
export const CreateManagedAccountIcon = withPlus(IconNetwork)
export const CreateWebhookIcon = withPlus(IconWebhook)
export const CreateApiTokenIcon = withPlus(IconKey)
export const CreateDigitalCertificateIcon = withPlus(IconCertificate)
export const CreateDomainIcon = IconWorldPlus
export const CreateAccessLinkIcon = IconLinkPlus
export const CreateKeyVaultIcon = withPlus(IconCloudLock)
export const CreateAffiliateCodeIcon = withPlus(IconTicket)
export const CreatePayoutMethodIcon = withPlus(IconCreditCard)
export const CreateSignerIcon = withPlus(IconUserCircle)
export const CreateTemplateFieldIcon = withPlus(IconForms)
export const CreateMcpConnectionIcon = withPlus(IconPlugConnected)
